document.addEventListener("product:variant-change", function (evt) {
    const mainProductBundlerVariantInput = document.getElementById('bundler-accessory-variant-input-main');
    if (mainProductBundlerVariantInput) {
        mainProductBundlerVariantInput.value = evt.detail.variant.id;
    }
});

document.addEventListener('DOMContentLoaded', function () {
    const bundlerCheckbox = document.getElementById('bundler-checkbox');
    if (bundlerCheckbox) {
        bundlerCheckbox.addEventListener('change', function() {
            const selectedElement = document.querySelector('.bundler-target-elements');
            if (selectedElement) {
                if (this.checked) {
                    selectedElement.classList.add('clicked');
                } else {
                    selectedElement.classList.remove('clicked');
                }
            }
        });
    }

    document.querySelectorAll('.bundler-accessory-variant-selector').forEach(selector => {
        selector.addEventListener('change', function() {
            const container = this.closest('.bundler-accessory-container');
            container.querySelectorAll('.bundler-accessory-price').forEach(p => p.classList.add('hidden'));
            container.querySelector(`[data-accessory-variant-id="${this.value}"]`)?.classList.remove('hidden');
            const priceContainer = document.querySelector('.bundler-checkbox-price');
            const discount = priceContainer.dataset.discount;
            let total = 0;
             document.querySelectorAll('.bundler-accessory-price:not(.hidden)').forEach(p => {
                total += parseFloat(p.dataset.accessoryVariantPrice) / 100;
             });
            const newPrice = total - (total * discount / 100);
            priceContainer.querySelector('s').textContent = `${total.toFixed(2)} лв.`;
            priceContainer.querySelector('span').textContent = `${newPrice.toFixed(2)} лв.`;
        });
    });

    document.querySelector('form .product-form__cart-submit').addEventListener('click', function (e) {
        if (bundlerCheckbox && bundlerCheckbox.checked) {
            e.preventDefault();
            document.querySelector('form .product-form__cart-submit').classList.add('loading');
            const quantity = document.querySelector('.product-form__quantity-and-buy-buttons-wrapper .quantity-input input').value;
            const bundleVariants = [];
            document.querySelectorAll('.bundler-accessory-variant-selector, .bundler-accessory-variant-input').forEach(function(element) {
                if (element.value) {
                    bundleVariants.push(element.value);
                }
            });
            const formData = {
                'items': bundleVariants.map(function(variantId) {
                    return {
                        'id': parseInt(variantId),
                        'quantity': quantity
                    };
                })
            };
            fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            })
            .then(response => response.json())
            .then(data => {
                window.location.href = '/checkout';
            })
            .catch(error => {
                console.error('Error adding bundle items:', error);
            });
        }
    });
});